import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import type { InstallationControlPoint } from '../../../app/ApiGen';
import type { Normalised } from '../../../utils/request';

export type IcpOption = Normalised<InstallationControlPoint>;

type RenderOptionProps = { option: IcpOption | null };

export const InstallationPointOption: React.VFC<RenderOptionProps> = ({ option }: RenderOptionProps) => {
  const { address, id } = option ?? {};
  if (address && id) {
    return (
      <Box>
        <Typography variant="body1">{id}</Typography>
        <Typography variant="caption">{address}</Typography>
      </Box>
    );
  }
  if (id) {
    return <Typography>&quot;{id}&quot;</Typography>;
  }
  return <Box />;
};
